/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_OBL_PAYMENT_PLANS_ITEM = {
  id: 'payment_plans_sidebar',
  screenId: 'tax-obl-payment-plans',
  label: 'Planes de Pago',
  description: 'Agrupá impuestos con interés por mora y financiá el total en cuotas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Armás un plan cuando tenés varios impuestos (por ejemplo IVA y un concepto 301) y, además del capital, hay interés por pagar fuera de término. Ese total se convierte en el capital del plan. Después lo financiás en cuotas: cada cuota muestra por separado el capital y el interés de la financiación.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Columnas: ID, Fecha, Descripción, Cuotas, Capital, Int. financ., Total, Pendiente, Estado.',
          'Tocá una fila para ver impuestos incluidos, cuotas y registrar el pago de una cuota.',
          'Estado: Confirmado, Parcialmente pagado, Pagado o Cancelado.',
        ],
        fields: [
          { label: 'Estado', description: 'Opcional. Filtra el listado.' },
        ],
      },
      {
        title: 'Paso 2 — Impuestos e interés por mora',
        intro: 'Botón +. Primero cargás cada impuesto:',
        fields: [
          { label: 'Impuesto', description: 'Elegí un impuesto del catálogo (IVA, 301 si lo tenés cargado, etc.).' },
          { label: 'Año / Mes', description: 'Período del impuesto.' },
          { label: 'Capital', description: 'Importe original (ej. IVA $100, 301 $200).' },
          { label: 'Interés mora', description: 'Interés por pagar fuera de término de ESE impuesto (ej. $5 de IVA y $10 del 301).' },
          {
            label: 'Cargar desde obligación pendiente',
            description:
              'Atajo: trae una obligación ya cargada en Obligaciones. El capital queda en el saldo pendiente; vos sumás el interés por mora.',
          },
        ],
        paragraphs: [
          'La suma de capital + interés por mora de todos los impuestos es el capital del plan. En el ejemplo: $105 de IVA + $210 del 301 = $315.',
        ],
      },
      {
        title: 'Paso 3 — Cuotas e interés de financiación',
        fields: [
          { label: 'Cuotas', description: 'Cantidad de cuotas (1 a 60).' },
          { label: '1er vencimiento', description: 'Fecha de la primera cuota. Las siguientes se calculan mes a mes.' },
          { label: 'Interés financiación', description: 'Interés del plan (no es el interés por mora). Se reparte en las cuotas, separado del capital.' },
        ],
        bullets: [
          'Tocá «Generar cuotas» para armar la tabla: número, vencimiento, capital, interés de financiación y total.',
          'Podés ajustar vencimientos o importes antes de guardar. La suma del capital de las cuotas debe coincidir con el capital del plan.',
        ],
      },
      {
        title: 'Paso 4 — Pagar cuotas',
        bullets: [
          'En el detalle del plan ves los impuestos incluidos y las cuotas con pagado / pendiente.',
          'Elegí la cuota, banco o caja, monto y fecha, y registrá el pago.',
          'Cuando se pagan todas las cuotas, las obligaciones que habías incluido quedan marcadas como pagadas.',
          'Si el plan no tiene pagos, podés eliminarlo: las obligaciones vuelven a quedar pendientes.',
        ],
      },
    ],
  },
}
